module.exports = __webpack_public_path__ + "static/img/5-2.c3c761f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/5-2.png
// module id = Bnmx
// module chunks = 10